export default __webpack_public_path__ + "static/media/agingResetAge.627b9603.jpg";